import { takeLatest, put, call, all, select } from 'redux-saga/effects';
import { changeEmail, resendConfirmationEmail } from '@api/user';
import {
  EMAIL_CHANGE_STARTED,
  EMAIL_RESEND,
  changeEmailSucceeded,
  changeEmailFailed,
} from '@redux/ducks/userDetails/userEmail';
import { setUserEmail, isAccountOwner } from '@redux/ducks/userDetails/userDetails';

// Watchers

export function* watchChangeEmail() {
  yield takeLatest(EMAIL_CHANGE_STARTED, changeEmailTask);
}

export function* watchResendEmail() {
  yield takeLatest(EMAIL_RESEND, resendEmailTask);
}

// Workers

export function* changeEmailTask({ payload }) {
  try {
    yield call(changeEmail, payload);

    yield put(setUserEmail({ email: payload.email }));

    const isEmailOwner = yield select(isAccountOwner);
    yield put(changeEmailSucceeded(isEmailOwner));
  } catch (err) {
    yield put(changeEmailFailed(err.data));
  }
}

export function* resendEmailTask({ payload }) {
  try {
    yield call(resendConfirmationEmail, payload);

    const isEmailOwner = yield select(isAccountOwner);
    yield put(changeEmailSucceeded(isEmailOwner));
  } catch (err) {
    yield put(changeEmailFailed(err.data));
  }
}

// Saga

export default function* userEmailSaga() {
  yield all([watchChangeEmail(), watchResendEmail()]);
}
